<div>
  <h1 mat-dialog-title *ngIf="action === 1">{{ "export" | translate }}</h1>
  <h1 mat-dialog-title *ngIf="action === 0">{{ "import" | translate }}</h1>
  <div mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>{{ "select-municipality" | translate }}</mat-label>
      <mat-select [(ngModel)]="model.municipalityId">
        <mat-option *ngFor="let municipality of municipalities" [value]="municipality.id">
          {{ municipality.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>{{ "select-template" | translate }}</mat-label>
      <mat-select [(ngModel)]="model.importType">
        <mat-option *ngFor="let type of enumValues" [value]="excelTemplateTypes[type]">
          {{ getExcelTemplateTypesDesc(excelTemplateTypes[type]) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="onProcess()">
      {{ "confirm" | translate }}
    </button>

    <button mat-raised-button [mat-dialog-close]="false">
      {{ "cancel" | translate }}
    </button>
  </div>
</div>
